export const pointZeroValue = '0pt'

const formatToPoint = (points?: number) => {
  if (points == undefined || points === null || Number.isNaN(points))
    return pointZeroValue

  return `${points.toLocaleString('jp-JP')}pt`
}

export default formatToPoint
